import script from "./icon-two-tones-status-up.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-two-tones-status-up.vue?vue&type=script&lang=ts&setup=true"

import "./icon-two-tones-status-up.vue?vue&type=style&index=0&id=08906aeb&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08906aeb"]])

export default __exports__